import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { getActivityTimestamp, getTooltipTimestamp } from 'shared/utils/time'

const Tooltip = styled(ReactTooltip)`
  color: #FFFFFF;
  background-color: #353A52;
  box-shadow: 0 4px 16px rgba(53, 58, 82, 0.08);
  padding: 8px 16px;
  font-size: 12rem;
  font-family: inherit;
`

const TimestampLabel = styled.span`
  color: ${props => (props.stampType === 'text') ? '#90A1B0' : '#FFFFFF'} ;
  background-color: ${props => (props.stampType === 'text' || props.stampType === 'small') ? 'transparent' : 'rgba(0, 0, 0, 0.5)'} ;
  font-size: 10rem;
  display: inline;
  border-radius: 4px;
  padding: 2px;
  position: absolute;
  right: ${props => props.stampType === 'small'? '0px' : '16px'};
  top: ${props => props.stampType === 'small'? '0px' : '16px'};
  cursor: pointer;
  &:hover{
    text-decoration: underline;    
  }
`
const Timestamp = ({stampType, time}) => {
  const shortTime = getActivityTimestamp(time)
  const tipTime =  getTooltipTimestamp(time)
  const tooltipId = 'tip_' + tipTime.replace(' ', '_')

  return (
    <React.Fragment>
      <TimestampLabel
        data-for={tooltipId}
        data-tip={tipTime}
        stampType={stampType}>
        {shortTime}
      </TimestampLabel>
      <Tooltip
        place="top"
        effect="solid"
        id={tooltipId}
        delayShow={400}
      />
    </React.Fragment>
  )
}


Timestamp.propTypes = {
  stampType: PropTypes.string,
  time: PropTypes.instanceOf(Date)
}

Timestamp.defaultProps = {
  stampType: 'text'
}

export default Timestamp
